import { Trans } from '@ui/i18n/trans';
import { Product } from '../product';
import { CheckIcon } from '@ui/icons/material/Check';

interface FeatureListProps {
  product: Product;
}

export function ProductFeatureList({ product }: FeatureListProps) {
  if (!product.feature_list.length) return null;

  return (
    <div className="pt-20">
      <div className="mb-10 text-sm font-semibold">
        {/* <Trans message="What's included" /> */}
      </div>
      {product.feature_list.map(feature => (
        <div key={feature} className="flex items-center gap-10 py-6 text-sm">
          <div className='key_bg'>
            <CheckIcon className="text-primary" size="sm" />
          </div>
          <Trans message={feature} />
        </div>
      ))}
    </div>
  );
}
